module.exports = __webpack_public_path__ + "img/hr-sand-1.b6c353dc.png";